// eslint-disable-next-line no-restricted-imports
import { OperationOrderFragment } from 'api/generated/graphql';
import {
  OrderMarketType,
  OrderOperationType,
  OrderStatusType,
  PrimaryClientType,
} from 'api/types/entity';
import { OperationOrderEntity } from 'api/types/entity/operation';
import { OrderExecutionTermsOrderType } from 'api/types/entity/order/orderExecutionTermsEntity';

export const parseOperationOrderEntity = (
  operationOrder: OperationOrderFragment
): OperationOrderEntity => ({
  id: operationOrder.id,
  number: operationOrder.number!,
  status: OrderStatusType[operationOrder.status],
  operationType: OrderOperationType[operationOrder.operationType],
  startDate: operationOrder.startDate
    ? new Date(operationOrder.startDate)
    : undefined,
  endDate: operationOrder.endDate
    ? new Date(operationOrder.endDate)
    : undefined,
  orderType: operationOrder.orderType
    ? OrderExecutionTermsOrderType[operationOrder.orderType]
    : undefined,
  marketType: operationOrder.marketType
    ? OrderMarketType[operationOrder.marketType]
    : undefined,
  isin: operationOrder.security.isin!,
  issueCode: operationOrder.security.issueCode ?? undefined,
  securityType: operationOrder.security.type ?? undefined,
  nominalValue: operationOrder.security.nominalValue ?? undefined,
  currency: operationOrder.currency!,
  ownerId: operationOrder.ownerId!,
  ownerFullName: operationOrder.ownerFullName ?? undefined,
  ownerType: PrimaryClientType[operationOrder.ownerType],
  ownerPersonalAccountNumber:
    operationOrder.ownerPersonalAccountNumber ?? undefined,
});
